import React, { useEffect, useState, useRef } from "react";
import { Grid } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import ReactPlayer from "react-player";
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import QuizIcon from "@mui/icons-material/Quiz";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardContent";
import Checkbox from '@mui/material/Checkbox';
//import { useCustomTheme } from "../api/ThemeProvider";
import "../styles/devices/mob_DataSet.css";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from '@mui/material';
import { Button } from "@mui/material";
import { pDatasetBuilderStates } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { CompareVideosDialogs } from "../components/dialog/CompareVideosDialogs";
import { Tooltip } from '@material-ui/core';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import Paper from "@mui/material/Paper";
import { pDataProvider } from "../utils/parameters";
import { data } from "@tensorflow/tfjs";
import { id } from "date-fns/locale";



// const arr_annotation_codes = [
//   "Signo no reconocido", 
//   "La configuración no es precisa", 
//   "Vídeo muy corto", 
//   "Calidad baja por iluminuación inadecuada", 
//   "Imagen desenfocada", 
//   "Manos borrosas en movimiento", 
//   "Encuadre muy cerano",
//   "La mano queda fuera del cuadro en parte del signo",
//   "Cámara muy baja",
//   "Cámara muy alta",
//   "Otro comentario"
// ];



// const dataSentenceReference = {
//   "sentence_id": "1717176852464_ifRfALIPdbcGQYii0cSbBcGc5cA3",
//   "timestamp": "1717176852464",
//   "origin": "DONATE_SENTENCE",
//   "user_id": "ifRfALIPdbcGQYii0cSbBcGc5cA3",
//   "reference_sentence_id": "806b4d6d-d4c3-452f-99a9-a0b5716a88bc",
//   "reference_sentence_label": "Estoy embarazada, sí",
//   "reference_sentence_glosses": "EMBARAZO YO SI(M-RO)",

//   "notEqualCases_diffSigns": false,
//   "notEqualCases_diffOrder": false,
//   "notEqualCases_diffNumberSigns": false,

//   "annotation_id": "1717176852464_ifRfALIPdbcGQYii0cSbBcGc5cA3",
//   "annotation_isValid": false,
//   "annotation_code": [],

//   "global_counter_total": 300,
//   "global_counter_revised": 100,
//   "global_counter_pending": 200,
// }

// const ARR_EVALUATION_OPTIONS = [
//   "Signo no reconocido", 
//   "La configuración no es precisa", 
//   "Vídeo muy corto", 
//   "Calidad baja por iluminuación inadecuada", 
//   "Imagen desenfocada", 
//   "Manos borrosas en movimiento", 
//   "Encuadre muy cerano",
//   "La mano queda fuera del cuadro en parte del signo",
//   "Cámara muy baja",
//   "Cámara muy alta",
//   "Otro comentario",
//   "Video necesita recorte",
// ];

const ARR_EVALUATION_OPTIONS = [
  "Vídeo muy corto", 
  "Video necesita recorte",
  "Calidad baja por iluminuación inadecuada", 
  "Imagen desenfocada", 
  "Manos borrosas en movimiento", 
  "La mano queda fuera del cuadro en parte del signo",
  "Cambia la traducción",
  "Otro comentario"
];

const dataSentenceReference = {
  "annotation_arr_options_idx": [],
  "annotation_arr_options_labels": [],
  "annotation_available": false,
  "annotation_comment": null,
  "annotation_isEqualCases": null,
  "annotation_notEqualCases_diffNumberSigns": null,
  "annotation_notEqualCases_diffOrder": null,
  "annotation_notEqualCases_diffSigns": null,
  "annotation_proposed_text": "",
  "global_counter_new": 1790,
  "global_counter_revised": 1,
  "global_counter_total": 1791,
  "notEqualCases_diffNumberSigns": false,
  "notEqualCases_diffOrder": false,
  "notEqualCases_diffSigns": false,
  "origin": "DONATE_SENTENCE",
  "reference_sentence_glosses": "ESPACIO PARA LAS GLOSAS",
  "reference_sentence_id": "bea892f8-cf3d-4f96-bd53-2def4f4b2b24",
  "reference_sentence_label": "Tengo mareos y visión borrosa",
  "record_id": "1716824029185_ifRfALIPdbcGQYii0cSbBcGc5cA3",
  "annotation_timestamp": "1716824029185",
  "user_id": "ifRfALIPdbcGQYii0cSbBcGc5cA3"
}


const TYPE_DATASET_OPTIONS = ["SIGNA IGUAL", "RESPUESTA LIBRE", "DELETREO"];

export function DatasetBuilderSentences() {

  const { token_id, currentUser, comm_getPublicURLVideoData } = useDataProvider();
  const { comm_getDatasetBuilderSentence, comm_sendDatasetBuilderSentence, comm_deleteDatasetBuilderSentence } = useCommProvider();

  const [typeDatasetOption, setTypeDatasetOption] = useState(TYPE_DATASET_OPTIONS[0]);
  const typeDatasetOptionRef = useRef(""); 

  const [videosDiscarded, setVideosDiscarded] = useState(false);
  const [sendButtonReady, setSendButtonReady] = useState(false);
  

  const [ requestRcv, setRequestRcv ] = useState(true);
  const [ dataSentence, setDataSentence ] = useState({});
  const [ dataSentenceServer, setDataSentenceServer ] = useState({});

  const updated_text_annotations = useRef(false); 
  const [annotationComment, setAnnotationComment] = useState("");
  const [annotationProposedText, setAnnotationProposedText] = useState("");

  const [ prevVideoAnnotated, setPrevVideoAnnotated ] = useState(false)
  const [ arrPrevVideoAnnotated, setArrPrevVideoAnnotated ] = useState([])
  const [ IDXArrPrevVideoAnnotated, setIDXArrPrevVideoAnnotated ] = useState(0)

  const [reload, setReload] = useState(false);
  const [subsetFILLAS, setSubsetFILLAS ] = useState(false);

  const handleReload = () => {
    setReload(true);
  };

  useEffect(() => {
    setTimeout(() => {
      setReload(false);
    }, 200);
  }, [reload]);


  // useEffect(() => {
  //   handleRequestNewVideo()
  // }, []);

  useEffect(() => {
    typeDatasetOptionRef.current = typeDatasetOption;
    handleRequestNewVideo()
  }, [typeDatasetOption, subsetFILLAS]);


  const handleTypeDatasetOptionChange = (event) => {
    setTypeDatasetOption(event.target.value);
  };

  const handleValidate = () => {
    setDataSentence((prevState) => ({
      ...prevState,
      status: "REVISED",
    }));
  };

  const handleDiscard = () => {
    setDataSentence((prevState) => ({
      ...prevState,
      status: "DISCARDED",
    }));
  };





  const getVideoResponseRef = () => {
    return comm_getPublicURLVideoData(pDataProvider.dir_vid_answer, dataSentence['reference_sentence_id']);   
  }

  const getVideoQuestionRef = () => {
    return comm_getPublicURLVideoData(pDataProvider.dir_vid_question, dataSentence['reference_sentence_id']);  
  }

  const getVideoFingerspellingRef = () => {
    return comm_getPublicURLVideoData(pDataProvider.dir_vid_donate_fingerspelling, dataSentence['record_id']);  
  }

  const getVideoReference = () => {
    if (typeDatasetOptionRef.current === "RESPUESTA LIBRE") {
      return getVideoQuestionRef(); 
    }
    if (typeDatasetOptionRef.current === "SIGNA IGUAL") {
      return getVideoResponseRef();
    }
    if (typeDatasetOptionRef.current === "DELETREO") {
      return null;
    }
  }



  const getVideoUser = () => {
    console.log("🚀 ~ getVideoUser ~ getVideoUser:", getVideoUser)
    if (typeDatasetOptionRef.current === "DELETREO") {
      return getVideoFingerspellingRef();
    }
    return comm_getPublicURLVideoData(pDataProvider.dir_vid_donate_sentence, dataSentence['record_id']);
  }

  const formatTextInformationSplit = () => {
    return "Total: "+ dataSentence['global_counter_total'] + " -- Revisados: " + dataSentence['global_counter_revised'] + " & Pendientes: " + dataSentence['global_counter_new'];
  }


  const handleSelectChange = (event) => {
    const { value } = event.target;
    console.log("🚀 ~ handleSelectChange ~ value:", value);

    const hasDiffSigns = value.includes('annotation_notEqualCases_diffSigns');
    const hasDiffOrder = value.includes('annotation_notEqualCases_diffOrder');
    const hasDiffNumberSigns = value.includes('annotation_notEqualCases_diffNumberSigns');
    const hasNone = value.includes('None') && value[value.length - 1] === 'None';

    const newState = {
        annotation_notEqualCases_diffSigns: hasNone ? false : hasDiffSigns,
        annotation_notEqualCases_diffOrder: hasNone ? false : hasDiffOrder,
        annotation_notEqualCases_diffNumberSigns: hasNone ? false : hasDiffNumberSigns,
        annotation_isEqualCases: hasNone || (!hasDiffSigns && !hasDiffOrder && !hasDiffNumberSigns)
    };

    setDataSentence((prevState) => ({
        ...prevState,
        ...newState,
    }));
  };

  const selectedOptions = [
    dataSentence.annotation_notEqualCases_diffSigns && 'annotation_notEqualCases_diffSigns',
    dataSentence.annotation_notEqualCases_diffOrder && 'annotation_notEqualCases_diffOrder',
    dataSentence.annotation_notEqualCases_diffNumberSigns && 'annotation_notEqualCases_diffNumberSigns',
  ].filter(Boolean);

  const noneSelected = selectedOptions.length === 0;
  


  const handleAnnotationOptionsChange = (event) => {
    const { value } = event.target;
    let newAnnotationOption = typeof value === 'string' ? value.split(',') : value;
    console.log("🚀 ~ handleAnnotationOptionsChange ~ newAnnotationOption:", newAnnotationOption)

    if (newAnnotationOption.includes('None') && newAnnotationOption[newAnnotationOption.length - 1] === 'None') {
      newAnnotationOption = [];
    }

    console.log("🚀 ~ handleAnnotationOptionsChange ~ PREVIO:", newAnnotationOption)
    

    if (newAnnotationOption[newAnnotationOption.length - 1] === ARR_EVALUATION_OPTIONS.indexOf("Cambia la traducción")) {
      newAnnotationOption.push(ARR_EVALUATION_OPTIONS.indexOf("Otro comentario"));
    }

    console.log("🚀 ~ handleAnnotationOptionsChange ~ POSTERIOR:", newAnnotationOption)
      
    

    setDataSentence((prevState) => ({
      ...prevState,
      annotation_arr_options_idx: newAnnotationOption,
    }));
  };


  useEffect(() => {
    // if (Array.isArray(dataSentence) && dataSentence.length === 0) {
    //   setRequestRcv(false);
    // } else {
    //   setRequestRcv(true);
    // }
    console.log("🚀 ~ DatasetBuilderSentences ~ dataSentenceServer:", dataSentenceServer)

    // if (dataSentence && Array.isArray(dataSentence["annotation_arr_options_labels"]) && dataSentence["annotation_arr_options_labels"].length === 0) {
    //   dataSentence["annotation_arr_options_labels"] = ARR_EVALUATION_OPTIONS;
    //   console.log("🚀 ~ DatasetBuilderSentences ~ dataSentence UPDATED DEFAULT:", dataSentence)
    // }

    if (dataSentenceServer && Array.isArray(dataSentenceServer["annotation_arr_options_labels"]) && dataSentenceServer["annotation_arr_options_labels"].length === 0) {
      dataSentenceServer["annotation_arr_options_labels"] = ARR_EVALUATION_OPTIONS
    }

    if (dataSentenceServer && dataSentenceServer["annotation_isEqualCases"] === null) {
      dataSentenceServer["annotation_notEqualCases_diffNumberSigns"] = dataSentenceServer["notEqualCases_diffNumberSigns"],
      dataSentenceServer["annotation_notEqualCases_diffOrder"] = dataSentenceServer["annotation_notEqualCases_diffOrder"],
      dataSentenceServer["annotation_notEqualCases_diffOrder"] = dataSentenceServer["annotation_notEqualCases_diffOrder"],
      dataSentenceServer["annotation_isEqualCases"] = !dataSentenceServer["notEqualCases_diffNumberSigns"] && !dataSentenceServer["notEqualCases_diffOrder"] && !dataSentenceServer["notEqualCases_diffSigns"]
    }else {
      console.log("🚀 ~ DatasetBuilderSentences ~ dataSentence: NO REPLACE ANNOTATION OPTIONS")
    }

    setAnnotationProposedText(dataSentenceServer["annotation_proposed_text"]);
    setAnnotationComment(dataSentenceServer["annotation_comment"]);

    if (dataSentenceServer["arr_records_annotated"]!==null){
      setArrPrevVideoAnnotated(dataSentenceServer["arr_records_annotated"])
    }

    setDataSentence(dataSentenceServer)
    
  }, [dataSentenceServer]);

  useEffect(() => {
    console.log("🚀 ~ dataSentence:", dataSentence)
  }, [dataSentence]);

  useEffect(() => {
    console.log("🚀 ~ arrPrevVideoAnnotated:", arrPrevVideoAnnotated)
  }, [arrPrevVideoAnnotated]);
  



  const otherCommentIndex = dataSentence.annotation_arr_options_labels ? dataSentence.annotation_arr_options_labels.indexOf("Otro comentario") : -1;

  const handleSendAnnotation = async () => {  
    
      console.log("🚀 ~ handleSendAnnotation ~ dataSentence:", dataSentence)

      const dataToSend = {
        "record_id": dataSentence["record_id"],
        "annotation_timestamp": dataSentence["annotation_timestamp"],
        "annotation_status": dataSentence["status"],
        "annotation_isEqualCases": dataSentence["annotation_isEqualCases"],
        "annotation_notEqualCases_diffSigns": dataSentence["annotation_notEqualCases_diffSigns"],
        "annotation_notEqualCases_diffOrder": dataSentence["annotation_notEqualCases_diffOrder"],
        "annotation_notEqualCases_diffNumberSigns": dataSentence["annotation_notEqualCases_diffNumberSigns"],
        "annotation_arr_options_labels": dataSentence["annotation_arr_options_labels"],
        "annotation_arr_options_idx": dataSentence["annotation_arr_options_idx"],
        "annotation_comment": dataSentence.annotation_arr_options_idx.includes(otherCommentIndex) ? (annotationComment ? annotationComment : "") : "",
        "annotation_proposed_text": annotationProposedText || "",
        "origin": typeDatasetOption
      }

      console.log("🚀 ~ handleSendAnnotation ~ dataToSend:", dataToSend)
    
      await comm_sendDatasetBuilderSentence(token_id, currentUser, dataToSend)
      if (IDXArrPrevVideoAnnotated === 0){
        handleRequestNewVideo()
      }
  
  }



  const handleRequestNewVideo = async () => {       
  
    //const filter_by_previous_sentence_id = dataSentence['reference_sentence_id'] ? dataSentence['reference_sentence_id'] : ""
    let filter_by_previous = ""
    if (typeDatasetOption === "DELETREO") {
      filter_by_previous = dataSentence['reference_sentence_label'] ? dataSentence['reference_sentence_label'] : ""
    }else{
      filter_by_previous = dataSentence['reference_sentence_id'] ? dataSentence['reference_sentence_id'] : ""
    }

    if (subsetFILLAS){
      setDataSentenceServer(await comm_getDatasetBuilderSentence(token_id, currentUser, "FILLAS", typeDatasetOption,"", filter_by_previous))
    }else{
      setDataSentenceServer(await comm_getDatasetBuilderSentence(token_id, currentUser, "", typeDatasetOption,"", filter_by_previous))
    }
    

    setPrevVideoAnnotated(false)
    setIDXArrPrevVideoAnnotated(0)

  }

  const handleRequestPrevAnnotationVideo = async () => {

    const IDX = arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated - 1
    console.log("🚀 ~ handleRequestPrevAnnotationVideo ~ handleRequestPrevAnnotationVideo:", arrPrevVideoAnnotated)
    console.log("🚀 ~ handleRequestPrevAnnotationVideo ~ handleRequestPrevAnnotationVideo:", arrPrevVideoAnnotated)
    console.log("🚀 ~ handleRequestPrevAnnotationVideo ~ handleRequestPrevAnnotationVideo:", arrPrevVideoAnnotated[IDX])

    if (subsetFILLAS){
      setDataSentenceServer(await comm_getDatasetBuilderSentence(token_id, currentUser, "FILLAS", typeDatasetOption,arrPrevVideoAnnotated[IDX]), "")
    }else{
      setDataSentenceServer(await comm_getDatasetBuilderSentence(token_id, currentUser, "", typeDatasetOption,arrPrevVideoAnnotated[IDX]),"")
    }

    setIDXArrPrevVideoAnnotated(IDXArrPrevVideoAnnotated + 1)

    setPrevVideoAnnotated(true)
  }


  const handleRequestPostAnnotationVideo = async () => {



    const IDX = arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated + 1
    console.log("🚀 ~ handleRequestPrevAnnotationVideo ~ handleRequestPrevAnnotationVideo:", arrPrevVideoAnnotated)
    console.log("🚀 ~ handleRequestPrevAnnotationVideo ~ handleRequestPrevAnnotationVideo:", arrPrevVideoAnnotated)
    console.log("🚀 ~ handleRequestPrevAnnotationVideo ~ handleRequestPrevAnnotationVideo:", arrPrevVideoAnnotated[IDX])

    if (subsetFILLAS){
      setDataSentenceServer(await comm_getDatasetBuilderSentence(token_id, currentUser, "FILLAS", typeDatasetOption,arrPrevVideoAnnotated[IDX]), "")
    }else{
      setDataSentenceServer(await comm_getDatasetBuilderSentence(token_id, currentUser, "", typeDatasetOption,arrPrevVideoAnnotated[IDX]),"")
    }

    setIDXArrPrevVideoAnnotated(IDXArrPrevVideoAnnotated - 1)

    setPrevVideoAnnotated(true)
  }
  

  const handleDeletePrevAnnotationVideo = async () => {
    await comm_deleteDatasetBuilderSentence(token_id, currentUser, typeDatasetOption, dataSentence["record_id"], dataSentence["annotation_timestamp"])
    setIDXArrPrevVideoAnnotated(0)
    handleRequestNewVideo()
  }
  


  return (
    <HomeWrapper>
      <PageTitle title="Revisión de vídeos" />
      <div className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer" style={{ display: 'flex', justifyContent: 'center' }}>
        {/* <Button className="sig_DataSet_ButtonConfirm" onClick={()=>setSubsetFILLAS(!subsetFILLAS)} style={{fontSize: '12px', width: '600px', color: 'white', backgroundColor: subsetFILLAS ? 'green' : '#f15656'}}> {subsetFILLAS ? "VIDEOS FILLAS MARÍA INMACULADA" : "VIDEOS FAXPG"}. Pulse para cambiar </Button> */}
      

        <FormControl style={{ width: '600px', marginTop:'5px' }}>
          <InputLabel  id="dataset-select-label">Selecciona el conjunto de videos</InputLabel>
          <Select
            labelId="dataset-select-label"
            id="dataset-select"
            value={subsetFILLAS ? 'fillas' : 'faxpg'}
            onChange={(e) => setSubsetFILLAS(e.target.value === 'fillas')}
            style={{margin: '5px'}}
          >
            <MenuItem value="faxpg">VIDEOS FAXPG</MenuItem>
            <MenuItem value="fillas">VIDEOS FILLAS MARÍA INMACULADA</MenuItem>
          </Select>
        </FormControl>
      </div>

      <Grid className="sig_DataSet_Root" style={{minHeight: '0px'}} container justifyContent="center" alignItems="center">
        <Card className="sig_DataSet_CardContainer" style={{ marginTop: '10px', border: '3px solid #5ea0d4', borderRadius: '10px' }}>
          <CardActionArea>
            <Grid container spacing={5}>
              <Grid item xs={6} style={{padding: '5px'}} container direction="column" alignItems="center">

              <Grid container alignItems="center" justifyContent="space-between">
                <Select style={{margin: '5px', flex: '1'}} value={typeDatasetOption} onChange={handleTypeDatasetOptionChange} fullWidth margin="normal">
                  {TYPE_DATASET_OPTIONS.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

                <TextField style={{ margin: '5px' }} variant="outlined" fullWidth margin="normal" InputProps={{readOnly: true}} value={formatTextInformationSplit()}/>

                {typeDatasetOption!=="DELETREO" &&
                  <ReactPlayer width="400px" height="400px" url={getVideoReference()} key={reload ? 'video1-reload' : 'video1'} controls muted/>
                }

                <TextField
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  style={{ 
                    margin: typeDatasetOption === "DELETREO" ? 'auto' : '5px'
                  }}
                  InputProps={{
                    readOnly: true,
                    style: { 
                      whiteSpace: 'pre-wrap', // Permitir que el texto se divida en varias líneas
                      fontSize: typeDatasetOption === "DELETREO" ? '40px' : "15px",
                      height: typeDatasetOption === "DELETREO" ? '200px' : "",
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center'
                    }
                  }}
                  multiline
                  rows={typeDatasetOption === "DELETREO" ? 2 : 3}
                  value={dataSentence['reference_sentence_label']}
                />

                {typeDatasetOption!=="DELETREO" &&
                  <TextField
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    style={{ margin: '5px', marginTop:'2px' }}
                    InputProps={{
                      readOnly: true,
                      style: { whiteSpace: 'pre-wrap', fontSize: '15px' } // Permitir que el texto se divida en varias líneas
                    }}
                    multiline
                    rows={3} // Número de filas
                    value={dataSentence['reference_sentence_glosses']}
                  />
                }                

                <div className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer" style={{ display: "flex", justifyContent: "space-between", flexWrap: "nowrap" }}>
                  {arrPrevVideoAnnotated !== undefined &&
                    <>
                      {
                        IDXArrPrevVideoAnnotated > 0 ? 
                        <>
                          <IconButton disabled={(arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated) < 1} onClick={handleRequestPrevAnnotationVideo} style={{ fontSize: '11px', width: '10%', border: "3px solid blue", flexShrink: 0 }}>
                            <ArrowCircleLeftRoundedIcon />
                          </IconButton>
                          <Button style={{ fontSize: '11px', border: "3px solid blue", marginRight: "5px", flexShrink: 0 }}>
                            {arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated} / {arrPrevVideoAnnotated.length}
                          </Button>
                          <IconButton disabled={(arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated) < 1} onClick={handleRequestPostAnnotationVideo} style={{ fontSize: '11px', width: '10%', border: "3px solid blue", flexShrink: 0 }}>
                            <ArrowCircleRightRoundedIcon />
                          </IconButton>
                        </> :
                        <>
                          <Button disabled={(arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated) < 1} className="sig_DataSet_ButtonConfirm" onClick={handleRequestPrevAnnotationVideo} style={{ fontSize: '11px', width: '20%', border: "3px solid blue", marginRight: "5px", flexShrink: 0 }}>
                            Anotación previa {arrPrevVideoAnnotated.length - IDXArrPrevVideoAnnotated} / {arrPrevVideoAnnotated.length}
                          </Button>
                        </> 
                      }
                     
                    </>
                  }
                  <Button className="sig_DataSet_ButtonConfirm" onClick={() => { handleRequestNewVideo(); setIDXArrPrevVideoAnnotated(0); }} style={{ fontSize: '11px', width: '30%', border: "3px solid green", flexShrink: 0 }}>                  Nueva grabación </Button>
                </div>
                
                { IDXArrPrevVideoAnnotated > 0 &&
                  <div className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer" style={{margin: "10px" }}>
                    <Button className="sig_DataSet_ButtonConfirm" onClick={handleDeletePrevAnnotationVideo} style={{border: "5px solid red"}}> Borrar anotación </Button>
                  </div>
                }

              </Grid>

              <Grid item xs={6} style={{padding: '5px', paddingRight: '15px'}} container direction="column" alignItems="center">
                {/* {requestRcv ? (
                <> */}
                <Grid style={{margin: '5px', height: '55px', width: '100%'}} container spacing={1}>
                  <Grid item xs={6} style={{ padding: 0 }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: dataSentence["status"] === "REVISED" ? 'green' : 'lightgray',
                        color: dataSentence["status"] === "REVISED" ? 'white' : 'black',
                        fontWeight: dataSentence["status"] === "REVISED" ? 'bold' : 'normal',
                        width: '100%',
                        borderRadius: '5px',
                        height: '100%',
                        boxShadow: 'none',
                        border: dataSentence["status"] === "REVISED" ? '5px solid green' : '5px solid white'
                      }}
                      onClick={handleValidate}
                      disabled={dataSentence["status"] === "REVISED"}
                    >
                      VALIDAR
                    </Button>
                  </Grid>
                  <Grid item xs={6} style={{ padding: 0 }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: dataSentence["status"] === "DISCARDED" ? 'red' : 'lightgray',
                        color: dataSentence["status"] === "DISCARDED" ? 'white' : 'black',
                        fontWeight: dataSentence["status"] === "DISCARDED" ? 'bold' : 'normal',
                        width: '100%',
                        borderRadius: '5px',
                        height: '100%',
                        boxShadow: 'none',
                        border: dataSentence["status"] === "DISCARDED" ? '5px solid red' : '5px solid white'
                      }}
                      onClick={handleDiscard}
                      disabled={dataSentence["status"] === "DISCARDED"}
                    >
                      DESCARTAR
                    </Button>
                  </Grid>
                </Grid>

                <Grid item style={{ margin: '5px' }}>
                      <FormControl className="sig_DataSet_Form sig_DataSet_FormAnotation">
                        <InputLabel>notEqualCases</InputLabel>
                        <Select
                          className="sig_DataSet_MenuList"
                          multiple
                          value={noneSelected ? ['None'] : selectedOptions}
                          label="notEqualCases"
                          onChange={handleSelectChange}
                        >
                          <MenuItem className="sig_DataSet_MenuListItem" value="None">
                            <Checkbox checked={noneSelected} />
                            None
                          </MenuItem>
                          <MenuItem className="sig_DataSet_MenuListItem" value="annotation_notEqualCases_diffSigns">
                            <Checkbox checked={dataSentence.annotation_notEqualCases_diffSigns} />
                            diffSigns
                          </MenuItem>
                          <MenuItem className="sig_DataSet_MenuListItem" value="annotation_notEqualCases_diffOrder">
                            <Checkbox checked={dataSentence.annotation_notEqualCases_diffOrder} />
                            diffOrder
                          </MenuItem>
                          <MenuItem className="sig_DataSet_MenuListItem" value="annotation_notEqualCases_diffNumberSigns">
                            <Checkbox checked={dataSentence.annotation_notEqualCases_diffNumberSigns} />
                            diffNumberSigns
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>



                <ReactPlayer width="400px" height="400px" url={getVideoUser()} key={reload ? 'video1-reload' : 'video1'} playing={true} controls muted/>

                {/* <TextField style={{ margin: '5px' }} label="Proponer otro texto" variant="outlined" fullWidth margin="normal" multiline  rows={2} /> */}
                <TextField
                  style={{ margin: '5px' }}
                  value={annotationProposedText}
                  // label="Proponer otro texto"
                  onChange={(e) => setAnnotationProposedText(e.target.value)}
                  fullWidth
                  margin="normal"
                  multiline  rows={2}
                  />

                  {dataSentence.annotation_arr_options_labels && (
                    <Grid item style={{ margin: '5px' }}>
                      <FormControl className="sig_DataSet_Form sig_DataSet_FormAnotation">
                        <InputLabel> Reportar anomalía </InputLabel>
                        <Select
                          className="sig_DataSet_MenuList"
                          multiple
                          value={dataSentence.annotation_arr_options_idx}
                          label="Reportar anomalía"
                          onChange={handleAnnotationOptionsChange}
                        >
                          <MenuItem className="sig_DataSet_MenuListItem" value="None">
                            <Checkbox checked={dataSentence.annotation_arr_options_idx.length === 0} />
                            None
                          </MenuItem>
                          {dataSentence.annotation_arr_options_labels.map((item, index) => (
                            <MenuItem className="sig_DataSet_MenuListItem" key={item} value={index}>
                              <Checkbox checked={dataSentence.annotation_arr_options_idx.includes(index)} />
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  {dataSentence.annotation_arr_options_idx && dataSentence.annotation_arr_options_idx.includes(otherCommentIndex) && (
                      <TextField
                        label= {dataSentence.annotation_arr_options_idx.includes(ARR_EVALUATION_OPTIONS.indexOf("Cambia la traducción")) ? "Otra traducción" : "Otro comentario"}
                        value={annotationComment}
                        fullWidth
                        margin="normal"
                        onChange={(e) => setAnnotationComment(e.target.value)}
                      />
                      
                    )}

                
                <div className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer">
                    <Button className="sig_DataSet_ButtonConfirm" onClick={handleReload} style={{color: 'white', backgroundColor: "#f15656"}}> Recargar vídeos </Button>
                  </div>

                <div className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer">
                  <Button className="sig_DataSet_ButtonConfirm" onClick={handleSendAnnotation} style={{border: `3px solid ${dataSentence["status"]!="NEW" ? 'green' : 'gray'}`}} disabled={dataSentence["status"]=="NEW"}>Enviar </Button>
                </div>
                {/* </>
                
                // (<>
                //   <div className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer" style={{ visibility: requestRcv ? 'visible' : 'hidden' }}>
                //     <Button className="sig_DataSet_ButtonConfirm" style={{border: `3px solid ${sendButtonReady ? 'green' : 'gray'}`}} disabled={!sendButtonReady}>Enviar </Button>
                //   </div>
                // </>) */}

              </Grid>
            </Grid>
            
          </CardActionArea>
         
        </Card>
      </Grid>
    </HomeWrapper>
  );
}
